import { render } from "./FormularioFamiliasPasoInicial.vue?vue&type=template&id=6f595d30&ts=true"
import script from "./FormularioFamiliasPasoInicial.vue?vue&type=script&lang=ts"
export * from "./FormularioFamiliasPasoInicial.vue?vue&type=script&lang=ts"

import exportComponent from "/home/runner/work/IAM-PlanCorresponsables/IAM-PlanCorresponsables/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__